export default __webpack_public_path__ + "static/media/line.a0fcf555.svg";